<a [ngClass]="{'dropdown-item':true,'disabled':disabled}" [ngStyle]="{'color': !disabled?color:'grey'}" [routerLinkActive]="link!=null ? 'active' : ''" [routerLink]="link" (click)="onClick()">
  <div class="row">
    <div class="col-2">
      <i [class]="icon" [title]="title"></i>
    </div>
    <div class="col-10">
      <span [ngClass]="{'navigation-item-label':true, 'd-none':!details}"><ng-content></ng-content></span>
    </div>
  </div>
</a>
